import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
  binarySearchyyczvdessj07 as binarySearch,
  mutableListOf6oorvk2mtdmp as mutableListOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  listOfvhqybd2zx248 as listOf_0,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  ParserStructure2cqp7gjft5io4 as ParserStructure,
  concat2z827ubu7ap26 as concat,
} from './Parser.mjs';
import { repeat2w4c6j8zoq09o as repeat } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  singleo93pzdgfc557 as single,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1n9qg6fb0b5i8 as toString_0,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { startsWith641pyr7vf687 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Companion_instances6yiyh4o0b70 as Companion_instance } from './ParseResult.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isAsciiDigit3p3aq858xklh as isAsciiDigit } from '../../util.mjs';
import { UnsignedIntConsumer25zhux255gkqb as UnsignedIntConsumer } from './NumberConsumer.mjs';
import { toString30pk9tzaqopn as toString_1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, withMinus) {
  withMinus = withMinus === VOID ? false : withMinus;
  var minNumberLength = (minDigits == null ? 1 : minDigits) + (withMinus ? 1 : 0) | 0;
  var tmp;
  if (maxDigits == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = withMinus ? maxDigits + 1 | 0 : maxDigits;
  }
  var tmp2_elvis_lhs = tmp;
  var maxNumberLength = tmp2_elvis_lhs == null ? 2147483647 : tmp2_elvis_lhs;
  var spacePadding_0 = spacePadding == null ? 0 : spacePadding;
  // Inline function 'kotlin.comparisons.minOf' call
  var maxPaddedNumberLength = Math.min(maxNumberLength, spacePadding_0);
  if (minNumberLength >= maxPaddedNumberLength)
    return spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, maxNumberLength);
  var accumulated = spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, minNumberLength);
  var inductionVariable = minNumberLength;
  if (inductionVariable < maxPaddedNumberLength)
    do {
      var accumulatedWidth = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      accumulated = new (ParserStructure())(emptyList(), listOf([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, accumulatedWidth + 1 | 0, accumulatedWidth + 1 | 0), concat(listOf([new (ParserStructure())(listOf_0(new (PlainStringParserOperation())(' ')), emptyList()), accumulated]))]));
    }
     while (inductionVariable < maxPaddedNumberLength);
  var tmp_0;
  if (spacePadding_0 > maxNumberLength) {
    var prepadding = new (PlainStringParserOperation())(repeat(' ', spacePadding_0 - maxNumberLength | 0));
    tmp_0 = concat(listOf([new (ParserStructure())(listOf_0(prepadding), emptyList()), accumulated]));
  } else if (spacePadding_0 === maxNumberLength) {
    tmp_0 = accumulated;
  } else {
    var r = new (ParserStructure())(emptyList(), listOf([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, spacePadding_0 + 1 | 0, maxNumberLength), accumulated]));
    tmp_0 = r;
  }
  return tmp_0;
}
var TrieNodeClass;
function TrieNode() {
  if (TrieNodeClass === VOID) {
    class $ {
      constructor(children, isTerminal) {
        var tmp;
        if (children === VOID) {
          // Inline function 'kotlin.collections.mutableListOf' call
          tmp = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        } else {
          tmp = children;
        }
        children = tmp;
        isTerminal = isTerminal === VOID ? false : isTerminal;
        this.children_1 = children;
        this.isTerminal_1 = isTerminal;
      }
    }
    initMetadataForClass($, 'TrieNode', TrieNode);
    TrieNodeClass = $;
  }
  return TrieNodeClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function StringSetParserOperation$reduceTrie$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.first_1;
  var tmp$ret$2 = b.first_1;
  return compareValues(tmp, tmp$ret$2);
}
function StringSetParserOperation$lambda($key) {
  return (it) => {
    var tmp$ret$0 = it.first_1;
    return compareValues(tmp$ret$0, $key);
  };
}
function _init_$reduceTrie(trie) {
  var _iterator__ex2g4s = trie.children_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var child = _iterator__ex2g4s.next_20eer_k$().component2_7eebsb_k$();
    _init_$reduceTrie(child);
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var newChildren = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_0 = trie.children_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var _destruct__k2r9zo = _iterator__ex2g4s_0.next_20eer_k$();
    var key = _destruct__k2r9zo.component1_7eebsc_k$();
    var child_0 = _destruct__k2r9zo.component2_7eebsb_k$();
    if (!child_0.isTerminal_1 && child_0.children_1.get_size_woubt6_k$() === 1) {
      var _destruct__k2r9zo_0 = single(child_0.children_1);
      var grandChildKey = _destruct__k2r9zo_0.component1_7eebsc_k$();
      var grandChild = _destruct__k2r9zo_0.component2_7eebsb_k$();
      newChildren.add_utx5q5_k$(to(key + grandChildKey, grandChild));
    } else {
      newChildren.add_utx5q5_k$(to(key, child_0));
    }
  }
  trie.children_1.clear_j9egeb_k$();
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = StringSetParserOperation$reduceTrie$lambda;
  var tmp$ret$2 = new (sam$kotlin_Comparator$0())(tmp);
  var tmp$ret$1 = sortedWith(newChildren, tmp$ret$2);
  trie.children_1.addAll_4lah1e_k$(tmp$ret$1);
}
var StringSetParserOperationClass;
function StringSetParserOperation() {
  if (StringSetParserOperationClass === VOID) {
    class $ {
      constructor(strings, setter, whatThisExpects) {
        this.setter_1 = setter;
        this.whatThisExpects_1 = whatThisExpects;
        this.trie_1 = new (TrieNode())();
        var _iterator__ex2g4s = strings.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var string = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.text.isNotEmpty' call
          // Inline function 'kotlin.require' call
          if (!(charSequenceLength(string) > 0)) {
            var message = 'Found an empty string in ' + this.whatThisExpects_1;
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
          }
          var node = this.trie_1;
          var inductionVariable = 0;
          var last = string.length;
          while (inductionVariable < last) {
            var char = charCodeAt(string, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0 = node.children_1;
            // Inline function 'kotlin.collections.binarySearchBy' call
            var key = toString_0(char);
            var toIndex = tmp0.get_size_woubt6_k$();
            var searchResult = binarySearch(tmp0, 0, toIndex, StringSetParserOperation$lambda(key));
            var tmp;
            if (searchResult < 0) {
              // Inline function 'kotlin.also' call
              var this_0 = new (TrieNode())();
              node.children_1.add_dl6gt3_k$((-searchResult | 0) - 1 | 0, to(toString_0(char), this_0));
              tmp = this_0;
            } else {
              tmp = node.children_1.get_c1px32_k$(searchResult).second_1;
            }
            node = tmp;
          }
          // Inline function 'kotlin.require' call
          if (!!node.isTerminal_1) {
            var message_0 = "The string '" + string + "' was passed several times";
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
          }
          node.isTerminal_1 = true;
        }
        _init_$reduceTrie(this.trie_1);
      }
      consume_ew3o91_k$(storage, input, startIndex) {
        var node = this.trie_1;
        var index = {_v: startIndex};
        var lastMatch = null;
        loop: while (index._v <= charSequenceLength(input)) {
          if (node.isTerminal_1)
            lastMatch = index._v;
          var _iterator__ex2g4s = node.children_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
            var key = _destruct__k2r9zo.component1_7eebsc_k$();
            var child = _destruct__k2r9zo.component2_7eebsb_k$();
            if (startsWith(input, key, index._v)) {
              node = child;
              index._v = index._v + key.length | 0;
              continue loop;
            }
          }
          break loop;
        }
        var tmp;
        if (!(lastMatch == null)) {
          // Inline function 'kotlin.text.substring' call
          var endIndex = lastMatch;
          var tmp$ret$0 = toString(charSequenceSubSequence(input, startIndex, endIndex));
          tmp = setWithoutReassigning(this.setter_1, storage, tmp$ret$0, startIndex, lastMatch);
        } else {
          var tmp_0 = Companion_instance;
          tmp = tmp_0.Error_ca056s_k$(startIndex, () => {
            var tmp0 = input;
            var tmp2 = startIndex;
            // Inline function 'kotlin.text.substring' call
            var endIndex = index._v;
            var tmp$ret$1 = toString(charSequenceSubSequence(tmp0, tmp2, endIndex));
            return 'Expected ' + this.whatThisExpects_1 + ' but got ' + tmp$ret$1;
          });
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'StringSetParserOperation');
    StringSetParserOperationClass = $;
  }
  return StringSetParserOperationClass;
}
function _get_whatThisExpects__4pg11j($this) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.consumers_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var length = item.get_length_g42xv3_k$();
    var tmp$ret$2 = (length == null ? 'at least one digit' : '' + length + ' digits') + (' for ' + item.whatThisExpects_1);
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  var consumerLengths = destination;
  var tmp;
  if ($this.isFlexible_1) {
    tmp = 'a number with at least ' + $this.minLength_1 + ' digits: ' + toString(consumerLengths);
  } else {
    tmp = 'a number with exactly ' + $this.minLength_1 + ' digits: ' + toString(consumerLengths);
  }
  return tmp;
}
function NumberSpanParserOperation$consume$lambda($numberString, this$0, $i, $error) {
  return () => "Can not interpret the string '" + $numberString + "' as " + this$0.consumers_1.get_c1px32_k$($i).whatThisExpects_1 + ': ' + $error.errorMessage_jwdivz_k$();
}
var NumberSpanParserOperationClass;
function NumberSpanParserOperation() {
  if (NumberSpanParserOperationClass === VOID) {
    class $ {
      constructor(consumers) {
        this.consumers_1 = consumers;
        var tmp = this;
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s = this.consumers_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp_0 = sum;
          var tmp0_elvis_lhs = element.get_length_g42xv3_k$();
          sum = tmp_0 + (tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs) | 0;
        }
        tmp.minLength_1 = sum;
        var tmp_1 = this;
        var tmp0 = this.consumers_1;
        var tmp$ret$2;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_2;
          if (isInterface(tmp0, Collection())) {
            tmp_2 = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$2 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            if (element_0.get_length_g42xv3_k$() == null) {
              tmp$ret$2 = true;
              break $l$block_0;
            }
          }
          tmp$ret$2 = false;
        }
        tmp_1.isFlexible_1 = tmp$ret$2;
        var tmp0_0 = this.consumers_1;
        var tmp$ret$4;
        $l$block_2: {
          // Inline function 'kotlin.collections.all' call
          var tmp_3;
          if (isInterface(tmp0_0, Collection())) {
            tmp_3 = tmp0_0.isEmpty_y1axqb_k$();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$4 = true;
            break $l$block_2;
          }
          var _iterator__ex2g4s_1 = tmp0_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
            var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
            var tmp0_elvis_lhs_0 = element_1.get_length_g42xv3_k$();
            if (!((tmp0_elvis_lhs_0 == null ? 2147483647 : tmp0_elvis_lhs_0) > 0)) {
              tmp$ret$4 = false;
              break $l$block_2;
            }
          }
          tmp$ret$4 = true;
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!tmp$ret$4) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var tmp0_1 = this.consumers_1;
        var tmp$ret$9;
        $l$block_3: {
          // Inline function 'kotlin.collections.count' call
          var tmp_4;
          if (isInterface(tmp0_1, Collection())) {
            tmp_4 = tmp0_1.isEmpty_y1axqb_k$();
          } else {
            tmp_4 = false;
          }
          if (tmp_4) {
            tmp$ret$9 = 0;
            break $l$block_3;
          }
          var count = 0;
          var _iterator__ex2g4s_2 = tmp0_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
            var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
            if (element_2.get_length_g42xv3_k$() == null) {
              count = count + 1 | 0;
              checkCountOverflow(count);
            }
          }
          tmp$ret$9 = count;
        }
        // Inline function 'kotlin.require' call
        if (!(tmp$ret$9 <= 1)) {
          // Inline function 'kotlin.collections.filter' call
          var tmp0_2 = this.consumers_1;
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s_3 = tmp0_2.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
            var element_3 = _iterator__ex2g4s_3.next_20eer_k$();
            if (element_3.get_length_g42xv3_k$() == null) {
              destination.add_utx5q5_k$(element_3);
            }
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(destination, 10));
          var _iterator__ex2g4s_4 = destination.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s_4.next_20eer_k$();
            var tmp$ret$18 = item.whatThisExpects_1;
            destination_0.add_utx5q5_k$(tmp$ret$18);
          }
          var fieldNames = destination_0;
          var message_0 = 'At most one variable-length numeric field in a row is allowed, but got several: ' + toString(fieldNames) + '. ' + "Parsing is undefined: for example, with variable-length month number and variable-length day of month, '111' can be parsed as Jan 11th or Nov 1st.";
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
      }
      consume_ew3o91_k$(storage, input, startIndex) {
        if ((startIndex + this.minLength_1 | 0) > charSequenceLength(input)) {
          var tmp = Companion_instance;
          return tmp.Error_ca056s_k$(startIndex, () => 'Unexpected end of input: yet to parse ' + _get_whatThisExpects__4pg11j(this));
        }
        var digitsInRow = {_v: 0};
        while ((startIndex + digitsInRow._v | 0) < charSequenceLength(input) && isAsciiDigit(charSequenceGet(input, startIndex + digitsInRow._v | 0))) {
          digitsInRow._v = digitsInRow._v + 1 | 0;
          digitsInRow._v;
        }
        if (digitsInRow._v < this.minLength_1) {
          var tmp_0 = Companion_instance;
          return tmp_0.Error_ca056s_k$(startIndex, () => 'Only found ' + digitsInRow._v + ' digits in a row, but need to parse ' + _get_whatThisExpects__4pg11j(this));
        }
        var index = startIndex;
        var inductionVariable = 0;
        var last = this.consumers_1.get_size_woubt6_k$() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0_elvis_lhs = this.consumers_1.get_c1px32_k$(i).get_length_g42xv3_k$();
            var length = tmp0_elvis_lhs == null ? (digitsInRow._v - this.minLength_1 | 0) + 1 | 0 : tmp0_elvis_lhs;
            var error = this.consumers_1.get_c1px32_k$(i).consume_o77i9d_k$(storage, input, index, index + length | 0);
            if (!(error == null)) {
              var tmp2 = index;
              // Inline function 'kotlin.text.substring' call
              var endIndex = index + length | 0;
              var numberString = toString(charSequenceSubSequence(input, tmp2, endIndex));
              var tmp_1 = Companion_instance;
              var tmp_2 = index;
              return tmp_1.Error_ca056s_k$(tmp_2, NumberSpanParserOperation$consume$lambda(numberString, this, i, error));
            }
            index = index + length | 0;
          }
           while (inductionVariable <= last);
        return Companion_instance.Ok_6vkbj8_k$(index);
      }
      toString() {
        return _get_whatThisExpects__4pg11j(this);
      }
    }
    initMetadataForClass($, 'NumberSpanParserOperation');
    NumberSpanParserOperationClass = $;
  }
  return NumberSpanParserOperationClass;
}
function SignedIntParser(minDigits, maxDigits, spacePadding, setter, name, plusOnExceedsWidth) {
  var parsers = mutableListOf([spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, true)]);
  if (!(plusOnExceedsWidth == null)) {
    parsers.add_utx5q5_k$(spaceAndZeroPaddedUnsignedInt(minDigits, plusOnExceedsWidth, spacePadding, setter, name));
    parsers.add_utx5q5_k$(new (ParserStructure())(listOf([new (PlainStringParserOperation())('+'), new (NumberSpanParserOperation())(listOf_0(new (UnsignedIntConsumer())(plusOnExceedsWidth + 1 | 0, maxDigits, setter, name, false)))]), emptyList()));
  } else {
    parsers.add_utx5q5_k$(spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name));
  }
  return new (ParserStructure())(emptyList(), parsers);
}
function PlainStringParserOperation$consume$lambda(this$0, $input, $startIndex, $i) {
  return () => {
    var tmp0 = $input;
    var tmp2 = $startIndex;
    // Inline function 'kotlin.text.substring' call
    var endIndex = ($startIndex + $i | 0) + 1 | 0;
    var tmp$ret$0 = toString(charSequenceSubSequence(tmp0, tmp2, endIndex));
    return 'Expected ' + this$0.string_1 + ' but got ' + tmp$ret$0;
  };
}
var PlainStringParserOperationClass;
function PlainStringParserOperation() {
  if (PlainStringParserOperationClass === VOID) {
    class $ {
      constructor(string) {
        this.string_1 = string;
        // Inline function 'kotlin.text.isNotEmpty' call
        var this_0 = this.string_1;
        // Inline function 'kotlin.require' call
        if (!(charSequenceLength(this_0) > 0)) {
          var message = 'Empty string is not allowed';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!!isAsciiDigit(charCodeAt(this.string_1, 0))) {
          var message_0 = "String '" + this.string_1 + "' starts with a digit";
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!!isAsciiDigit(charCodeAt(this.string_1, this.string_1.length - 1 | 0))) {
          var message_1 = "String '" + this.string_1 + "' ends with a digit";
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
        }
      }
      consume_ew3o91_k$(storage, input, startIndex) {
        if ((startIndex + this.string_1.length | 0) > charSequenceLength(input)) {
          var tmp = Companion_instance;
          return tmp.Error_ca056s_k$(startIndex, () => "Unexpected end of input: yet to parse '" + this.string_1 + "'");
        }
        var inductionVariable = 0;
        var last = charSequenceLength(this.string_1) - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(charSequenceGet(input, startIndex + i | 0) === charCodeAt(this.string_1, i))) {
              var tmp_0 = Companion_instance;
              return tmp_0.Error_ca056s_k$(startIndex, PlainStringParserOperation$consume$lambda(this, input, startIndex, i));
            }
          }
           while (inductionVariable <= last);
        return Companion_instance.Ok_6vkbj8_k$(startIndex + this.string_1.length | 0);
      }
      toString() {
        return "'" + this.string_1 + "'";
      }
    }
    initMetadataForClass($, 'PlainStringParserOperation');
    PlainStringParserOperationClass = $;
  }
  return PlainStringParserOperationClass;
}
var SignParserClass;
function SignParser() {
  if (SignParserClass === VOID) {
    class $ {
      constructor(isNegativeSetter, withPlusSign, whatThisExpects) {
        this.isNegativeSetter_1 = isNegativeSetter;
        this.withPlusSign_1 = withPlusSign;
        this.whatThisExpects_1 = whatThisExpects;
      }
      consume_ew3o91_k$(storage, input, startIndex) {
        if (startIndex >= charSequenceLength(input))
          return Companion_instance.Ok_6vkbj8_k$(startIndex);
        var char = charSequenceGet(input, startIndex);
        if (char === _Char___init__impl__6a9atx(45)) {
          this.isNegativeSetter_1(storage, true);
          return Companion_instance.Ok_6vkbj8_k$(startIndex + 1 | 0);
        }
        if (char === _Char___init__impl__6a9atx(43) && this.withPlusSign_1) {
          this.isNegativeSetter_1(storage, false);
          return Companion_instance.Ok_6vkbj8_k$(startIndex + 1 | 0);
        }
        var tmp = Companion_instance;
        return tmp.Error_ca056s_k$(startIndex, () => 'Expected ' + this.whatThisExpects_1 + ' but got ' + toString_0(char));
      }
      toString() {
        return this.whatThisExpects_1;
      }
    }
    initMetadataForClass($, 'SignParser');
    SignParserClass = $;
  }
  return SignParserClass;
}
var UnconditionalModificationClass;
function UnconditionalModification() {
  if (UnconditionalModificationClass === VOID) {
    class $ {
      constructor(operation) {
        this.operation_1 = operation;
      }
      consume_ew3o91_k$(storage, input, startIndex) {
        this.operation_1(storage);
        return Companion_instance.Ok_6vkbj8_k$(startIndex);
      }
    }
    initMetadataForClass($, 'UnconditionalModification');
    UnconditionalModificationClass = $;
  }
  return UnconditionalModificationClass;
}
function setWithoutReassigning(_this__u8e3s4, receiver, value, position, nextIndex) {
  var conflictingValue = _this__u8e3s4.trySetWithoutReassigning_itlg4a_k$(receiver, value);
  var tmp;
  if (conflictingValue === null) {
    tmp = Companion_instance.Ok_6vkbj8_k$(nextIndex);
  } else {
    var tmp_0 = Companion_instance;
    tmp = tmp_0.Error_ca056s_k$(position, () => "Attempting to assign conflicting values '" + toString_1(conflictingValue) + "' and '" + toString_1(value) + "' to field '" + _this__u8e3s4.get_name_woqyms_k$() + "'");
  }
  return tmp;
}
function spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths($withMinus, $setter, $name, minNumberLength, maxNumberLength) {
  // Inline function 'kotlin.check' call
  if (!(maxNumberLength >= (1 + ($withMinus ? 1 : 0) | 0))) {
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
  }
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  if ($withMinus) {
    this_0.add_utx5q5_k$(new (PlainStringParserOperation())('-'));
  }
  this_0.add_utx5q5_k$(new (NumberSpanParserOperation())(listOf_0(new (UnsignedIntConsumer())(minNumberLength - ($withMinus ? 1 : 0) | 0, maxNumberLength - ($withMinus ? 1 : 0) | 0, $setter, $name, $withMinus))));
  var tmp$ret$1 = this_0.build_nmwvly_k$();
  return new (ParserStructure())(tmp$ret$1, emptyList());
}
//region block: exports
export {
  NumberSpanParserOperation as NumberSpanParserOperation3qyp02c4km7yu,
  PlainStringParserOperation as PlainStringParserOperation3o6zmwb0f0e6n,
  SignParser as SignParserj94qlnys16wg,
  SignedIntParser as SignedIntParsergn6823y2nf4q,
  StringSetParserOperation as StringSetParserOperation82b6pl2fn98q,
  UnconditionalModification as UnconditionalModification151pp4lqfue9i,
  spaceAndZeroPaddedUnsignedInt as spaceAndZeroPaddedUnsignedInt3iec50j4qusnr,
};
//endregion

//# sourceMappingURL=ParserOperation.mjs.map
